import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/sign/:token',
    name: 'sign',
    component: () => import('./views/SignView.vue'),
    props: true,
  },
  // Ancienne page statique sans champ de saisie : le code est désormais demandé
  // dans une fenêtre de la page de signature. Un lien resté en historique y mène.
  {
    path: '/sign/:token/otp',
    redirect: (to) => ({ path: `/sign/${String(to.params.token)}` }),
  },
  {
    path: '/sign/:token/done',
    name: 'sign-done',
    component: () => import('./views/DoneView.vue'),
    props: true,
  },
  // Liens envoyés quand SIGNER_BASE_URL omettait `/sign` (staging, octobre 2026).
  // Le motif ne retient que la forme d'un jeton (32 octets en base64url).
  {
    path: '/:token([A-Za-z0-9_-]{43})',
    redirect: (to) => ({ path: `/sign/${String(to.params.token)}` }),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('./views/NotFoundView.vue'),
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
